/**
 * Every React Query key that holds a copy of the buyer's favourites.
 *
 * WHY THIS IS A LIST AND NOT ONE KEY. Four surfaces cache the collection under
 * three unrelated roots, and they were never invalidated together:
 *
 *   ['saved-cards', 'all']                  membership, `useFavourites`
 *   ['saved-cards', { page, limit }]        `/collection` and the dashboard tab
 *   ['saved-cards-summary', { limit }]      the dashboard count/value tile
 *   ['saved-cards-preview']                 the profile panel
 *
 * `invalidateQueries` matches on a key PREFIX, so `['saved-cards']` covers the
 * first two and matches neither of the last two — and `['saved-cards', 'all']`,
 * which is what this branch shipped with, covers only the membership query.
 * Everything else kept serving a stale answer for the app's global five-minute
 * `staleTime` (App.js), so hearting a card on /marketplace and then opening
 * /collection inside five minutes showed a collection without it in.
 *
 * One helper, called from every write, so the next surface that caches this
 * list is added in one place rather than three.
 */
export const FAVOURITE_QUERY_KEYS = [
  ['saved-cards'],
  ['saved-cards-summary'],
  ['saved-cards-preview'],
];

export function invalidateFavourites(queryClient) {
  return Promise.all(
    FAVOURITE_QUERY_KEYS.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  );
}

export default invalidateFavourites;
